module.exports = __webpack_public_path__ + "static/media/no-reports.cdde0e80.svg";